module.exports = __webpack_public_path__ + "img/scan-me.b2436b4b.png";